import styled from "styled-components";
import AirbnbMsool from "../../../../../assets/svg/AirbnbMsool.svg?react";
import CloseMenu from "../../../../../assets/svg/closeMenu.svg?react";
import AutomationImg from "@assets/svg/AutomationImg.svg?react";

interface ResponsiveProps {
  $isPhone?: boolean;
  $BgColor?: string;
  $TextColor?: string;
  $width?: string;
}

export const ModalBox = styled.div<ResponsiveProps>`
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  width: ${({ $isPhone }) => ($isPhone ? "90%" : "673")};
  max-width: 100%;
  text-align: center;
  direction: rtl;
`;

export const ActionContainer = styled.div<ResponsiveProps>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  justify-content: ${({ $isPhone }) => ($isPhone ? "center" : "flex-end")};
  height: ${({ $isPhone }) => ($isPhone ? "80px" : "97px")};
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  background: white;
  padding-inline: 32px;
`;

export const StyledButton = styled.button<ResponsiveProps>`
  width: ${({ $width }) => $width || "auto"};
  height: 49px;
  border-radius: 69px;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: ${({ $TextColor }) => $TextColor};
  background-color: ${({ $BgColor }) => $BgColor};
  border: 1px solid #5b3fff;
  cursor: pointer;

  &:hover {
    background-color: ${({ $BgColor }) => $BgColor};
    color: ${({ $TextColor }) => $TextColor};
  }
`;

export const CloseButtonContainer = styled.div<ResponsiveProps>`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 64px;
  cursor: pointer;

  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "32px")};
`;

export const StyledAirbnbIcon = styled(AirbnbMsool)<ResponsiveProps>`
  width: ${({ $isPhone }) => ($isPhone ? "120px" : "160px")};
  height: ${({ $isPhone }) => ($isPhone ? "56px" : "74px")};
`;

// styles/AutomateReservationsModal.ts (continue to extend this file)

export const SectionWrapper = styled.section`
  display: flex;
`;

export const TextContainer = styled.div`
  width: 336px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 16px;
  padding-inline: 24px;
  padding-top: 25px;
  border-bottom: 1px solid #e0e0e0;
`;

export const HeaderTitle = styled.span`
  font-weight: 700;
  font-size: 20px;
  color: #331860;
  width: 288px;
  text-align: start;
`;

export const HeaderSubtitle = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #4e4d59;
  width: 288px;
  text-align: start;
`;

export const FeaturesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: start;
  padding: 16px;
`;

export const FeatureItem = styled.div<{ selected: boolean }>`
  padding: 10px 16px;
  border: 1px solid ${({ selected }) => (selected ? "#5B3FFF" : "#dcdcdc")};
  border-radius: 999px;
  background-color: #f9f9f9;
  color: ${({ selected }) => (selected ? "#5B3FFF" : "#331860")};
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
  transition: 0.2s;
`;

export const TimeSavedRow = styled.div`
  display: flex;
  width: 100%;
  padding-inline: 25px;
  gap: 5px;
  font-weight: 400;
  font-size: 16px;
  color: #4e4d59;
`;

export const TimeSavedHighlight = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: #5b3fff;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background: #f7f4ff;
  padding-bottom: 50px;
`;

export const StyledCloseIcon = styled(CloseMenu)`
  background: white;
  border-radius: 50%;
  padding: 10px;
  width: 40px;
  height: 40px;
`;

export const StyledAutomationImg = styled(AutomationImg)`
  width: 337px;
  height: 472px;
  flex: 1;
  margin-top: 50px;
`;
